// extracted by mini-css-extract-plugin
export var productImage = "_h0-1";
export var viewLink = "_h0-2";
export var wishlistItem = "_h0-0";